import HomeSVG from "@design-system/ui-icons/vanilla/Home"
import { createIcon } from "../createIcon"

export const HomeIcon = createIcon(HomeSVG)
